<template>
  <div class="form-group" :class="{'input-box': showInputBox}">
    <i v-if="addEmailNotification"
       class="glyphicon glyphicon-envelope"
       v-tooltip="'Email might be generated'"
       title="Email might be generated">
    </i>

    <span class="form-group">
      <label :class="{ 'text-danger': hasErrors(getFieldName) }"> {{label}} </label>
      <comments v-if="addComment" :field-name="getCommentfieldName" :model-name="modelName"></comments>
      <br>
      <small class="form-text text-muted" v-if="subtext">
        {{subtext}}
      </small>
    </span>

    <div class="radio">
      <slot name="choices"></slot>

      <label class="radio-inline" v-for="(choice, index) in choices" :key="index">
        <input type="radio"
               v-model.lazy="inputVal"
               :name="getFieldName"
               :data-vv-as="label"
               :value="choice.value"
               :disabled="isReadOnly || disabled"
               v-bind="$attrs"
               v-validate.immediate="vvalidate">
           {{ choice.display }}
      </label>
    </div>

    <span v-show="errors.has(getFieldName)" class="text-danger">{{ errors.first(getFieldName) }}</span>

    <div v-show="hasErrors(getFieldName)">
      <span v-for="(error, index) in errorsFor(getFieldName)" class="text-danger" :key="`error_${getFieldName}_${index}`">
        {{error}}
      </span>
    </div>
		<slot></slot>
  </div>
</template>

<script>
import CustomInputMixin from './CustomInputMixin'

export default {
  name: 'RadioInput',
  mixins: [CustomInputMixin],
  props: {
    choices: Array
  }
}
</script>

<style scoped>
i {
  margin-right: 0.5em;
}
</style>
